import { render, staticRenderFns } from "./FieldRichText.vue?vue&type=template&id=4d26027b&"
import script from "./FieldRichText.vue?vue&type=script&lang=js&"
export * from "./FieldRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports